import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ClinicEnvironmentService } from '../../clinic-environment.service';
import { ApiService } from '../api.service';
import { SettingMonitorOutpatientQueue } from 'src/app/shared/models/antrian/setting-monitor-outpatient-queue.model';
import { SettingMonitorOutpatientQueueAdapter } from '../../adapter/antrian/setting-monitor-outpatient-queue.adapter.service';

@Injectable({
  providedIn: 'root',
})
export class SettingMonitorOutpatientQueueApiService
  implements ApiService<SettingMonitorOutpatientQueue>
{
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  constructor(
    private clinicEnvService: ClinicEnvironmentService,
    private http: HttpClient,
    private adapter: SettingMonitorOutpatientQueueAdapter
  ) {}

  public getAll(): Observable<SettingMonitorOutpatientQueue[]> {
    return this.http
      .get(
        `${environment.urlV2}/data-klinik/${this.clinicEnvService.clinicId}/setting-monitor-outpatient-queue`
      )
      .pipe(
        map((res: any) => {
          if (!res || !res?.responses) {
            return [];
          }
          return res.responses.settingMonitorPoliklinik.map((item: SettingMonitorOutpatientQueue) =>
            this.adapter.adapt(item)
          );
        }),
        catchError((err) => throwError(err))
      );
  }

  public fetchBySettingNumber(settingNumber: number): Observable<SettingMonitorOutpatientQueue[]> {
    return this.http
      .get(
        `${environment.urlV2}/data-klinik/${this.clinicEnvService.clinicId}/setting-monitor-outpatient-queue/setting-number/${settingNumber}`
      )
      .pipe(
        map((res: any) => {
          if (!res || !res?.responses) {
            return [];
          }
          return res.responses.settingMonitorPoliklinik.map((item: SettingMonitorOutpatientQueue) =>
            this.adapter.adapt(item)
          );
        }),
        catchError((err) => throwError(err))
      );
  }

  public createOrUpdate(data: any): Observable<any> {
    return this.http
      .post(
        `${environment.urlV2}/data-klinik/${this.clinicEnvService.clinicId}/setting-monitor-outpatient-queue`,
        data,
        this.httpOptions
      )
      .pipe(catchError((err) => throwError(err)));
  }
}
